import UtilityService from "../services/UtillityServices/UtilityService";

const useVetrinaCorsiConfigTable = () => {
    return [
        {
            key: 'denominazione_corso',
            label: 'Corso',
        },
        {
            key: 'modalita_erogazione',
            label: 'Modalità',
        },
        {
            key: 'max_iscritti',
            label: 'Max Iscritti',
            formatter: (value) => value === 0 ? 'Illimitati' : value,
            className: 'text-center'
        },
        {
            key: 'periodo',
            label: 'Periodo Svolgimento',
            formatter: (value, row) => {
                if (!row.data_inizio || !row.data_fine) return 'N/D';
                return `${UtilityService.formatDate(row.data_inizio)} - ${UtilityService.formatDate(row.data_fine)}`;
            }
        }
    ];
};

export default useVetrinaCorsiConfigTable;